var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvoice = function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5c0-.8.7-1.5 1.5-1.5H20v7.5c0 .8-.7 1.5-1.5 1.5S17 8.3 17 7.5V5.1l-4.4 4.4c-.6.6-1.5.6-2.1 0-.6-.5-.6-1.5-.1-2.1L14.9 3h-2.4c-.8 0-1.5-.7-1.5-1.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 19h14v-8H1v8zm7-2c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgInvoice;